export enum ClubDetailsFields {
  Id = 'id',
  OwnerName = 'ownerName',
  OwnerEmail = 'ownerEmail',
  DirectorName = 'directorName',
  DirectorEmail = 'directorEmail',
  DirectorPhoneNumber = 'directorPhoneNumber',
}

export const ClubDetailsLabels = {
  [ClubDetailsFields.Id]: 'Id',
  [ClubDetailsFields.OwnerName]: 'Club Owner Name',
  [ClubDetailsFields.OwnerEmail]: 'Club Owner Email',
  [ClubDetailsFields.DirectorName]: 'Club Director Name',
  [ClubDetailsFields.DirectorEmail]: 'Club Director Email',
  [ClubDetailsFields.DirectorPhoneNumber]: 'Club Director Phone Number',
};
